module.exports = __webpack_public_path__ + "static/media/nehas-bags.bd1d846f.png";